module.exports = __webpack_public_path__ + "static/media/loader.022d160a.svg";